import React, { Suspense } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";

import clsx from "clsx";
import {
  Box,
  Typography,
  Paper,
  Grid,
  Chip,
  useTheme,
} from "@material-ui/core";
import { useEffect } from "react";
import { useContext } from "react";
import { useState } from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import SiteAddDialog from "./siteAddDialog";
import PacketAddDialog from "./packetAddDialog";
import { MasterContext } from "../../context/master";
import TaskDisplayer from "../../components/interaction/taskDisplayer";
import { JET_PRESS_SITE_CREATE } from "../../constants/taskTypes";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTools } from "@fortawesome/free-solid-svg-icons";
import * as Icons from "@fortawesome/free-brands-svg-icons";
import { ErrorBoundary } from "react-error-boundary";
import * as Sentry from "@sentry/browser";
import UserAccess from "../../reducers/userAccess";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "20px",
  },
  title: {
    color: theme.palette.textLight.main,
  },
  heading: {
    display: "flex",
    alignItems: "center",
    fontSize: theme.typography.pxToRem(17),
    fontWeight: theme.typography.fontWeightBold,
  },
  infoLabel: {
    textTransform: "uppercase",
    border: "none",
    outline: 0,
    padding: "4px 9px 3px 8px",
    fontSize: "0.75rem",
    transition:
      "background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    whiteSpace: "nowrap",
    borderRadius: "16px",
  },
  infoText: {
    backgroundColor: theme.palette.primary.main,
    color: "#000",
  },
}));

export default function MyWebsites(props) {
  const ExpansionPanel = React.lazy(() => import("./expansionPanel"));
  const classes = useStyles();
  const { t } = useTranslation();
  const context = useContext(MasterContext);
  const theme = useTheme();
  const [siteData, setSiteData] = useState([]);
  const accountID = props.match && props.match.params && props.match.params.id;
  const [dataRefresh, setDataRefresh] = useState(false);
  const [siteSlotRemained, setSiteSlotRemained] = useState(0);
  const [accountName, setAccountName] = React.useState();
  const [isLoading, setIsLoading] = useState(true);
  
  const userAccess = useSelector((state) => state.userAccess);

  useEffect(() => {
    context.GetSites().then((response) => {
      response.filter &&
        setSiteData(
          accountID
            ? response.filter(
                (site) => site.Site.AccountId === parseInt(accountID)
              )
            : response
        );
      setIsLoading(false);
    });

    if (accountID) {
      context.GetAccounts().then((response) => {
        response &&
          response
            .filter(
              (account) => account.Account.Account_ID === parseInt(accountID)
            )
            .map((account) =>
              setSiteSlotRemained(
                account.Account.LimitWebSpaces - account.Sites.length
              )
            );
        response

          .filter(
            (account) => account.Account.Account_ID === parseInt(accountID)
          )
          .map((account) => setAccountName(account.Account.Account_Name));
      });
    } else {
      context.GetAccounts().then((response) => {
        response &&
          response
            .filter(
              (account) => account.Sites.length < account.Account.LimitWebSpaces
            )
            .map((account) =>
              setSiteSlotRemained(
                account.Account.LimitWebSpaces - account.Sites.length
              )
            );
      });
    }
  }, [accountID, context]);

  useEffect(() => {
    dataRefresh &&
      context.GetSites().then((response) => {
        response.filter &&
          setSiteData(
            accountID
              ? response.filter(
                  (site) => site.Site.AccountId === parseInt(accountID)
                )
              : response
          );
        setIsLoading(false);
      });

    setDataRefresh(false);
  }, [accountID, context, dataRefresh]);

  const [siteTheme, setSiteTheme] = useState(
    siteData.map((site, siteID) =>
      site.Instances.map((instance, instanceID) => {
        var temp =
          instance.InstanceDetails.Themes[
            instance.InstanceDetails.List[0].Theme
          ]?.Title;
        return temp;
      })
    )
  );

  const [siteCount, setSiteCount] = useState(
    siteData.map((site, siteID) => Object.keys(site.Instances).length)
  );

  const [disableStaging, setDisableStaging] = useState(false);

  useEffect(() => {
    if (siteCount > 1) {
      setDisableStaging(siteCount);
    } else {
      //setDisableStaging(false);
    }
  }, [siteCount]);

  useEffect(() => {
    setSiteTheme(
      siteData.map((site, siteID) =>
        site.Instances.map(
          (instance, instanceID) =>
            instance.InstanceDetails.Themes[
              instance.InstanceDetails.List[0].Theme
            ]?.Title ?? ""
        )
      )
    );
    var tempSiteCount = siteData.map(
      (site, siteID) => Object.entries(site.Instances).length
    );
    setSiteCount(tempSiteCount);
    
  }, [siteData]);

  const handleClearCacheClick = () => {
    setDataRefresh(true);
  };

  const siteStatusWriter = (statusNumber) => {
    switch (statusNumber) {
      case 1:
        return t("Stopped By User");
      case 2:
        return t("Stopped By Administrator");
      case 3:
        return t("Created In Queue");
      case 4:
        return t("Deleted In Queue");
      case 6:
        return t("Restoroing");
      case 7:
        return t("Deleted");
      default:
        return t("Technical Error, Please Contact with Customer Service");
    }
  };

  function ErrorDiv({ error }) {
    Sentry.withScope((scope) => {
      scope.setTag("CATEGORY", "REACT_ERROR_BOUNDARIES");
      scope.setTag("CUSTOMERID", userAccess.customerID )
      Sentry.captureException(error);
    });

    return (
      <Box mb={3}>
        <Grid
          container
          spacing={3}
          justify="space-between"
          direction="row"
          wrap="wrap"
          alignItems="center"
        >
          <Grid item md={12}>
            <Paper style={{ padding: theme.spacing(3), minHeight: "75px" }}>
              <span
                className={classes.heading}
                style={{ placeContent: "center" }}
              >
                <span>
                  <span
                    style={{
                      color: theme.palette.urlTexts.primary,
                      marginRight: theme.spacing(2),
                    }}
                  >
                    {t(
                      "An error has occurred on your website. Our support teams were informed about the issue."
                    )}
                  </span>
                </span>
              </span>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    );
  }
  return (
    <>
      <Container
        className={classes.root}
        key={siteData.length}
        maxWidth={false}
      >
        {isLoading === true && (
          <Box mb={3}>
            <Skeleton variant="rect" animation="wave" height={74}></Skeleton>
          </Box>
        )}
        {siteData.map((site, siteID, sites) => (
          <React.Fragment key={siteID * 3}>
            {siteID === 0 && (
              <Box key={siteID * 2} mt={3} mb={1}>
                <Box>
                  <Typography variant="h5" className={classes.title}>
                    {site.Site.AccountName +
                      " - " +
                      t(site.Site.AccountPackageName)}
                  </Typography>
                </Box>
              </Box>
            )}
            {siteID > 0 &&
              sites[siteID].Site.AccountId !==
                sites[siteID - 1]?.Site?.AccountId &&
              sites[siteID].Site.AccountId !==
                sites[siteID + 1]?.Site?.AccountId && (
                <Box key={siteID * 2} mt={3} mb={1}>
                  <Box>
                    <Typography variant="h5" className={classes.title}>
                      {sites[siteID].Site.AccountName +
                        " - " +
                        t(sites[siteID].Site.AccountPackageName)}
                    </Typography>
                  </Box>
                </Box>
              )}
            {site.Site.SiteStatus === 0 ? (
              site.Instances.map((instance, instanceID, instances) => (
                <div key={instanceID}>
                  <Suspense
                    fallback={
                      <Box mb={3}>
                        <Skeleton
                          variant="rect"
                          animation="wave"
                          height={74}
                        ></Skeleton>
                      </Box>
                    }
                  >
                    <ErrorBoundary FallbackComponent={ErrorDiv}>
                      <ExpansionPanel
                        index={siteID * 10 + instanceID}
                        order={siteID}
                        TransitionProps={{ unmountOnExit: true }}
                        instance={instance}
                        JetPressGuid={instance.jetpressGUID}
                        site={site.Site}
                        Thema={siteTheme}
                        DataRefresh={dataRefresh}
                        AccountName={accountName}
                        StagingDisable={site.Instances}
                        ClearCacheClick={() => handleClearCacheClick()}
                        {...props}
                      ></ExpansionPanel>
                    </ErrorBoundary>
                  </Suspense>
                </div>
              ))
            ) : (
              <Box mb={2}>
                <Grid
                  container
                  spacing={3}
                  justify="space-between"
                  direction="row"
                  wrap="wrap"
                  alignItems="center"
                >
                  <Grid item md={12}>
                    <Paper
                      style={{ padding: theme.spacing(3), minHeight: "75px" }}
                    >
                      <span className={classes.heading}>
                        <FontAwesomeIcon
                          style={{ opacity: 1, marginRight: 8 }}
                          size="2x"
                          icon={Icons.faWordpress}
                        ></FontAwesomeIcon>

                        <span>
                          <span
                            style={{
                              color: theme.palette.urlTexts.primary,
                              marginRight: theme.spacing(2),
                            }}
                          >
                            {site.Site.HostName}
                          </span>
                          <span
                            style={{ position: "relative", top: 0, left: 0 }}
                          >
                            <span
                              style={{ marginLeft: theme.spacing(2) }}
                              className={clsx(
                                classes.infoLabel,
                                classes.infoText
                              )}
                            >
                              {siteStatusWriter(site.Site.SiteStatus)}
                            </span>
                          </span>
                        </span>
                      </span>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>
            )}
          </React.Fragment>
        ))}
      </Container>
      {siteSlotRemained > 0 ? (
        <TaskDisplayer Type={JET_PRESS_SITE_CREATE} AccountID={accountID}>
          <SiteAddDialog AccountID={accountID} />
        </TaskDisplayer>
      ) : (
        <PacketAddDialog AccountID={accountID} />
      )}
    </>
  );
}
